import { Check, Loader2 } from "lucide-react";

export const DraftProgressPane = ({ jobStage, elapsed }) => {
  const percent = jobStage === "validating" ? 90 : Math.min(78, 10 + elapsed * 1.1);
  const steps = [
    { label: "Searching the library & selecting evidence", state: "done" },
    { label: "Writing the draft", state: jobStage === "validating" ? "done" : "active" },
    { label: "Validating citations & building references", state: jobStage === "validating" ? "active" : "pending" },
  ];
  return (
    <div className="bg-white border border-slate-200 rounded-xl min-h-[560px] flex items-center justify-center p-10 shadow-sm" data-testid="research-progress-pane">
      <div className="w-full max-w-md text-center">
        <div className="w-16 h-16 border-2 border-slate-200 border-t-orange-500 rounded-full animate-spin mx-auto" />
        <h2 className="text-2xl font-semibold text-slate-900 mt-6">
          {jobStage === "validating" ? "Validating citations & references" : "Writing your draft"}
        </h2>
        <p className="text-sm text-slate-500 mt-2">Runs in the background — you can leave this page and find the finished draft in Past drafts.</p>
        <div className="mt-6 h-2 rounded-full bg-slate-100 overflow-hidden">
          <div className="h-full bg-orange-500 rounded-full transition-all duration-700" style={{ width: `${percent}%` }} data-testid="research-progress-bar" />
        </div>
        <div className="mt-5 space-y-2 text-left text-sm">
          {steps.map((step) => (
            <div key={step.label} className={`flex items-center gap-2 ${step.state === "pending" ? "text-slate-400" : "text-slate-700"}`}>
              {step.state === "done"
                ? <Check className="w-4 h-4 text-emerald-600 shrink-0" />
                : step.state === "active"
                  ? <Loader2 className="w-4 h-4 animate-spin text-orange-500 shrink-0" />
                  : <span className="w-4 h-4 rounded-full border border-slate-300 inline-block shrink-0" />}
              <span>{step.label}</span>
            </div>
          ))}
        </div>
        <p className="text-[11px] text-slate-400 mt-5">{elapsed}s elapsed · typically 40–90 seconds</p>
      </div>
    </div>
  );
};
